module.exports = __webpack_public_path__ + "img/btn2.bda05d8.png";